import React from "react";

export default ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24">
  <path fill="currentColor" d="M6.264.19L5.19 1.265a.65.65 0 000 .92L14.984 12 5.19 21.817a.65.65 0 000 .92l1.074 1.073a.65.65 0 00.92 0l11.349-11.35a.65.65 0 000-.92L7.183.19a.65.65 0 00-.92 0z"/>
</svg>
